import React from 'react';
import styles from './disabled-form-overlay.scss';
import { useTranslation } from '@wix/form-fields';
import { Text } from 'wix-ui-tpa/cssVars';
export const DisabledFormOverlay = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: styles.disabledFormOverlay },
        React.createElement(Text, null, t('form.disabled.fallback-message'))));
};
//# sourceMappingURL=disabled-form-overlay.js.map